module.exports = {
  'language': '<a href="/en/login">English</a> | <a href="/zh-cn/login">\u7b80\u4f53\u4e2d\u6587</a> | <a href="/zh-tw/login">\u7e41\u9ad4\u4e2d\u6587</a>',
  'userProc': '\u8cc7\u6599\u7dad\u8b77',
  'userProc_01': '\u63d0\u55ae\u67e5\u8a62',
  'userProc_02': '\u65b0\u589e\u7a7a\u904b\u63d0\u55ae',
  'userProc_03': '\u65b0\u589e\u6d77\u904b\u63d0\u55ae',
  'adminProc': '\u7cfb\u7d71\u7ba1\u7406',
  'adminProc_01': '\u65b0\u589e\u7528\u6236\u8cc7\u6599',
  'adminProc_02': '\u7ba1\u7406\u7528\u6236\u8cc7\u6599',
  'adminProc_03': '\u65b0\u589e\u8ca8\u6cc1\u8cc7\u6599',
  'adminProc_04': '\u7ba1\u7406\u8ca8\u6cc1\u8cc7\u6599',
  'adminProc_05': '\u65b0\u589e\u5ba2\u6236Mail',
  'adminProc_06': '\u7ba1\u7406\u5ba2\u6236Mail',
  'user': '(\u7528\u6236)\u63d0\u55ae\u67e5\u8a62',
  'company': '(\u5206\u516c\u53f8/\u4ee3\u7406)\u63d0\u55ae\u67e5\u8a62',
  'logon_out': '\u9000\u51fa\u7cfb\u7d71',
  'logon_out_01': '\u9000\u51fa\u767b\u9678',
  'anonymou_cw': 'CW',
  'upload_INV_PO': '\u4e0a\u50b3INV & PO',
  'errorform': '\u63d0\u55ae\u865f\u78bc\u4e0d\u80fd\u70ba\u7a7a',
  'errorstate': '\u72c0\u614b\u4ee3\u78bc\u4e0d\u80fd\u70ba\u7a7a',
  'addokerror': '{0}\u63d0\u55ae\u589e\u52a0\u6210\u529f!',
  'requst': '{0}\u5fc5\u9808\u586b\u5beb!',
  'addother': '{0}\u589e\u52a0\u6210\u529f!',
  'errorall': '\u81f3\u5c11\u586b\u5beb\u4e00\u9805!',
  'errorlogon': '\u932f\u8aa4\u7684\u7528\u6236\u540d\u6216\u5bc6\u78bc!',
  'errorusercode': '\u7528\u6236\u4ee3\u78bc\u5fc5\u9808\u586b\u5beb',
  'errorusername': '\u7528\u6236\u540d\u7a31\u5fc5\u9808\u586b\u5beb',
  'errorctnr': '\u8ca8\u6ac3\u865f\u5fc5\u9808\u586b\u5beb!',
  'other1': 'Invoice P/O\u8cc7\u6599',
  'other2': '\u63d0\u55ae\u72c0\u614b\u8cc7\u6599',
  'other3': '\u65b0\u7528\u6236',
  'other4': '\u8ca8\u6cc1\u8cc7\u6599',
  'other5': '\u7528\u6236Mail\u8cc7\u6599',
  'other6': '\u8ca8\u6ac3\u8cc7\u6599',
  'existerror': '\u63d0\u55ae\u865f:{0} \u5df2\u5b58\u5728,\u8acb\u91cd\u65b0\u9304\u5165',
  'existerruser': '\u7528\u6236{0},\u5df2\u7d93\u5b58\u5728',
  'existcnee': '\u8ca8\u6ac3\u865f{0},\u5df2\u7d93\u5b58\u5728',
  'existerrstatus': '\u8ca8\u6cc1\u4ee3\u78bc{0},\u5df2\u7d93\u5b58\u5728',
  'errorstatecode': '\u8ca8\u6cc1\u4ee3\u78bc\u5fc5\u9808\u586b\u5beb',
  'error': '\u932f\u8aa4!',
  'error_in': '\u53ef\u80fd\u767c\u751f\u932f\u8aa4\u539f\u56de\u5982\u4e0b:',
  'error_in_01': '\u60a8\u767b\u9678\u8d85\u6642,\u8acb\u91cd\u65b0\u767b\u9678.',
  'error_in_02': '\u7121\u6548\u6216\u975e\u6cd5\u7684\u93c8\u63a5.',
  'error_in_03': '\u60a8\u7121\u6b0a\u700f\u89bd\u672c\u9801.',
  'login': '\u767b\u5165',
  'submit': '\u9001\u51fa',
  'reset': '\u91cd\u586b',
  'currpage': '\u7576\u524d\u9801:',
  'rec': '\u8a18\u9304\u6578:',
  'currlocation': '\u7576\u524d\u4f4d\u7f6e',
  'inquiry': '\u63d0\u55ae\u67e5\u8a62',
  'inputno': '\u8f38\u5165\u55ae\u865f',
  'userid': '\u7528 \u6236',
  'password': '\u5bc6 \u78bc',
  'welcom': '\u6b61\u8fce\u4f86\u5230\u6377\u8fc5\u7269\u6d41\u5168\u7403\u8ca8\u7269\u8ffd\u8e64\u67e5\u8a62\u7cfb\u7d71',
  'home_img': 'home_zh.gif',
  'return_img': 'return_zh.gif',
  'home': '\u8fd4\u56de\u9996\u9801',
  'return': '\u8fd4\u56de\u4e0a\u9801',
  'index': '\u9996\u9801',
  'dot': '\u00b7',
  'result': '\u67e5\u8a62\u7d50\u679c',
  'insert': '\u65b0\u589e\u8a18\u9304',
  'input': '\u8acb\u8f38\u5165',
  'logon_welcom': '\u6b61\u8fce\u767b\u9678',
  'logon_guest': '\u5ba2\u4eba',
  'totalcount': '\u8a2a\u554f\u7d71\u8a08',
  'search': '\u641c\u7d22',
  'index_title': 'GLS Tracking System',
  'index_word1': '\u9ede\u9019\u88e1\u6309\u63d0\u55ae\u865f\u67e5\u8a62(\u7121\u9700\u767b\u9678)',
  'index_word2': '\u8f38\u5165\u63d0\u55ae\u865f(\u6bcf\u865f\u4e00\u884c,\u5fc5\u9808\u586b\u5beb)',
  'anonymou_title': '\u63d0\u55ae\u67e5\u8a62',
  'anonymou_currpage': '\u63d0\u55ae\u67e5\u8a62\u7d50\u679c',
  'anonymou_house_no': '\u63d0\u55ae\u865f\u78bc',
  'anonymou_orgn_code': '\u8d77\u904b\u9ede',
  'anonymou_dest_code': '\u76ee\u7684\u5730',
  'anonymou_qty': '\u4ef6\u6578',
  'anonymou_gw': '\u91cd\u91cf',
  'anonymou_vw': '\u9ad4\u7a4d',
  'anonymou_state_dates31': '\u8d77\u904b\u8d77\u98db\u6642\u9593',
  'anonymou_state_dates33': '\u5230\u9054\u76ee\u7684\u5730\u6642\u9593',
  'anonymou_detail': '\u8a73\u7d30',
  'anonymoudetail_title': '\u63d0\u55ae\u8a73\u7d30\u8cc7\u6599',
  'anonymoudetail_statedetail': '\u63d0\u55ae\u72c0\u614b\u8aaa\u660e',
  'anonymoudetail_state': '\u63d0\u55ae\u72c0\u614b\u767c\u751f\u6642\u9593',
  'anonymoudetail_remake': '\u5099\u8a3b\u8aaa\u660e',
  'anonymou_cnee_name': '\u6536\u8ca8\u4eba',
  'anonymou_info_term': 'INCO TERM',
  'normal_title': '\u7528\u6236\u63d0\u55ae\u67e5\u8a62',
  'air': '\u63d0\u55ae\u67e5\u8a62\u7d50\u679c(\u7a7a\u904b)',
  'sea': '\u63d0\u55ae\u67e5\u8a62\u7d50\u679c(\u6d77\u904b)',
  'normal_to1_code': 'AIRPORT ',
  'normal_detail': '\u63d0\u55ae\u660e\u7d30<br>( P/O Inv | \u6587\u6a94 | \u72c0\u614b)',
  'normal_detailsea': '\u63d0\u55ae\u660e\u7d30<br>(\u8ca8\u6ac3 | P/O Inv | \u6587\u6a94 | \u72c0\u614b)',
  'normal_word1': '\u9078\u64c7\u689d\u4ef6',
  'normal_selectawb': '\u63d0\u55ae\u865f',
  'normal_selectinv': '\u767c\u7968\u7de8\u865f',
  'normal_selectpo': '\u5ba2\u6236\u8a02\u55ae\u865f',
  'normal_selectpart': '\u6599\u865f',
  'normal_selectcont': '\u7bb1\u865f',
  'normal_etd': '\u5230\u9054\u6642\u9593',
  'normal_inqtype': '\u67e5\u8a62\u985e\u578b',
  'normal_air': '\u7a7a\u904b',
  'normal_sea': '\u6d77\u904b',
  'normal_state_dates31': '\u8d77\u904b\u6642\u9593',
  'normal_word2': '\u8ca8\u6ac3',
  'normal_word3': 'P/O Inv',
  'normal_word4': '\u6587\u6a94',
  'normal_word5': '\u72c0\u614b',
  'normal_doc_title': '\u6587\u6a94\u8cc7\u6599',
  'normal_info': '\u8a73\u7d30\u8cc7\u6599',
  'normal_billtype': '\u63d0\u55ae\u985e\u578b',
  'normal_mawb': '\u4e3b\u63d0\u55ae\u865f\u78bc',
  'normal_billdate': '\u63d0\u55ae\u65e5\u671f',
  'normal_shprename': '\u767c\u8ca8\u4eba',
  'normal_shprcode': '\u767c\u8ca8\u4eba\u4ee3\u78bc',
  'normal_shpradd': '\u767c\u8ca8\u4eba\u5730\u5740',
  'normal_orgncode': '\u51fa\u767c\u5730',
  'normal_dest': '\u76ee\u7684\u5730',
  'normal_fligde': '\u822a\u73ed\u4fe1\u606f',
  'normal_city': '\u57ce\u5e02',
  'normal_flino': '\u73ed\u6a5f\u7de8\u865f',
  'normal_inq_etd': '\u8d77\u904b\u65e5',
  'normal_etd': '\u9810\u5b9a\u8d77\u98db\u65e5',
  'normal_eta': '\u9810\u5b9a\u5230\u9054\u65e5',
  'normal_first': '\u7b2c\u4e00\u6bb5',
  'normal_sec': '\u7b2c\u4e8c\u6bb5',
  'normal_thir': '\u7b2c\u4e09\u6bb5',
  'normal_pkg': '\u7e3d\u4ef6\u6578',
  'normal_pkgde': '\u5305\u88dd\u8aaa\u660e',
  'normal_comm': '\u54c1\u540d',
  'normal_marks': '\u8868\u982d\u5167\u5bb9',
  'normal_descp': '\u660e\u7d30\u5167\u5bb9',
  'normal_consignee': '\u6536\u8ca8\u4eba',
  'normal_cneecode': '\u6536\u8ca8\u4eba\u4ee3\u78bc',
  'normal_cneeadd': '\u6536\u8ca8\u4eba\u5730\u5740',
  'normal_sea_closedate': '\u7d50\u95dc\u65e5',
  'normal_sea_etd': '\u958b\u822a\u65e5',
  'normal_sea_eta': '\u62b5\u9054\u65e5',
  'normal_sea_loading': '\u88dd\u6ac3\u65b9\u5f0f',
  'normal_sea_portre': '\u6536\u8ca8\u5730',
  'normal_sea_portl': '\u88dd\u8ca8\u6e2f',
  'normal_sea_portdh': '\u5378\u8ca8\u6e2f',
  'normal_sea_protdl': '\u9001\u8ca8\u5730',
  'normal_cnee_curr': '\u8ca8\u6ac3\u8a73\u7d30',
  'normal_cnee_container': '\u8ca8\u6ac3\u865f\u78bc',
  'normal_cnee_seal': '\u5c01\u689d\u865f',
  'normal_cnee_type': '\u8ca8\u6ac3\u985e\u578b',
  'normal_cnee_load': '\u88dd\u6ac3\u985e\u578b',
  'normal_cnee_cuft': '\u9ad4\u7a4d(CBM/CBF)',
  'normal_sea_cbm': '\u9ad4\u7a4d(\u7c73)',
  'normal_sea_cbf': '\u9ad4\u7a4d(\u544e)',
  'normal_po_title': 'P/O Inv\u8a73\u7d30\u8cc7\u6599',
  'normal_po_inv': '\u767c\u7968\u865f',
  'normal_po_no': '\u8a02\u55ae\u865f',
  'normal_po_part': '\u5ba2\u6236\u6599\u865f',
  'normal_po_remark': '\u5099\u8a3b\u8aaa\u660e',
  'normal_po_cartonno': '\u51fa\u8ca8\u7bb1\u865f',
  'normal_state_title': '\u72c0\u614b\u8a73\u7d30\u8cc7\u6599',
  'company_title': '\u63d0\u55ae\u67e5\u8a62',
  'company_inquiryby': '\u67e5\u8a62\u65b9\u5f0f',
  'company_house': '\u63d0\u55ae',
  'company_masterno': '\u4e3b\u63d0\u55ae\u865f',
  'company_houseno': '\u526f\u63d0\u55ae\u865f',
  'company_consol': 'Consol Data',
  'company_consol_detail': '\u63d0\u55ae\u8a73\u7d30',
  'document_word1': '\u64cd\u4f5c',
  'document_word2': '\u4fee\u6539',
  'document_word3': '\u522a\u9664',
  'document_invpo_title': '\u65b0\u589e/\u4fee\u6539Inv PO\u8cc7\u6599',
  'document_state_title': '\u65b0\u589e/\u4fee\u6539\u63d0\u55ae\u72c0\u614b\u8cc7\u6599',
  'document_state_code': '\u72c0\u614b\u4ee3\u78bc',
  'document_state_ename': '\u72c0\u614b\u8aaa\u660e(\u82f1)',
  'document_state_cname': '\u72c0\u614b\u8aaa\u660e(\u7e41)',
  'document_state_sname': '\u72c0\u614b\u8aaa\u660e(\u7c21)',
  'document_state_date': '\u72c0\u614b\u65e5\u671f/\u6642\u9593',
  'document_cnee_title': '\u65b0\u589e/\u4fee\u6539\u8ca8\u6ac3\u8cc7\u6599',
  'document_air_title': '\u65b0\u589e/\u4fee\u6539\u7a7a\u904b\u63d0\u55ae',
  'document_sea_title': '\u65b0\u589e/\u4fee\u6539\u6d77\u904b\u63d0\u55ae',
  'pkg': '\u4ef6\u6578',
  'gw': '\u6bdb\u91cd',
  'cw': '\u8a08\u50f9\u91cd',
  'vw': '\u6750\u7a4d\u91cd',
  'currency': '\u5e63\u5225',
  'freight': '\u904b\u8cbb\u4ed8\u8cbb\u65b9\u5f0f',
  'other': '\u96dc\u8cbb\u4ed8\u8cbb\u65b9\u5f0f',
  'vessel': '\u8239\u671f\u7de8\u865f',
  'voyage': '\u822a\u7dda',
  'carrier': '\u8239\u52d9\u516c\u53f8(\u7de8\u865f/\u540d)',
  'invoice': '\u5e33\u55ae',
  'document': '\u6587\u6a94',
  'declaration': '\u5831\u55ae',
  'delivery': '\u7c3d\u6536\u55ae',
  'norecord_word1': '\u5c0d\u4e0d\u8d77,\u6c92\u6709\u60a8\u6240\u9700\u8981\u7684\u8a18\u9304.',
  'admin_user_title': '\u65b0\u589e/\u4fee\u6539\u7528\u6236\u8cc7\u6599',
  'admin_user_submit': '\u67e5\u8a62',
  'admin_user_code': '\u7528\u6236\u4ee3\u78bc',
  'admin_user_name': '\u7528\u6236\u540d\u7a31',
  'admin_user_type': '\u7528\u6236\u985e\u5225',
  'admin_user_pass': '\u7528\u6236\u5bc6\u78bc',
  'admin_user_email': 'Email\u5730\u5740',
  'admin_user_typeA': '\u7ba1\u7406\u54e1',
  'admin_user_typeB': '\u666e\u901a\u7528\u6236',
  'admin_user_typeC': '\u516c\u53f8\u7528\u6236',
  'admin_user_typeD': '\u8cc7\u6599\u7dad\u8b77\u8005',
  'admin_status_title': '\u65b0\u589e/\u4fee\u6539\u8ca8\u6cc1\u8cc7\u6599',
  'admin_status_code': '\u8ca8\u6cc1\u4ee3\u78bc',
  'admin_status_ename': '\u8ca8\u6cc1\u540d\u7a31(\u82f1)',
  'admin_status_cname': '\u8ca8\u6cc1\u540d\u7a31(\u7e41)',
  'admin_status_sname': '\u8ca8\u6cc1\u540d\u7a31(\u7c21)',
  'admin_mailout_title': '\u65b0\u589e/\u4fee\u6539\u5ba2\u6236Mail\u8cc7\u6599',
  'admin_mailout_email': 'Email\u5730\u5740',
  'select_all': '\u5168\u90e8',
  'freight_s': '\u904b\u8cbb\u6761\u4ef6',
  'export_excel': '\u5c0e\u51faExcel',
  'no_upload_file': '\u672a\u4e0a\u50b3\u6587\u4ef6',
  'save_upload_file_error': '\u4e0a\u50b3\u6587\u4ef6\u63a5\u6536\u5931\u6557',
  'successful_upload': '\u6587\u4ef6\u4e0a\u50b3\u6210\u529f,\u6b63\u5728\u89e3\u6790\u6578\u64da..',
  'msg_manifest_content_error': '\u7b2c %s \u884c  %s \u6578\u64da\u932f\u8aa4!',
  'msg_error1': '\u7b2c  %s \u884c [%s] \u672a\u67e5\u8a62\u5230\u6578\u64da',
  'msg_error2': '\u7b2c  %s \u884c [%s] \u5fc5\u9808\u8f38\u5165',
  'msg_error3': '\u6578\u64da\u4fdd\u5b58\u6210\u529f',
  'msg_error4': '\u6578\u64da\u4fdd\u5b58\u5931\u6557',
  'm_Download_title1': '\u4e0b\u8f09Excel\u6a21\u677f',
  'export_excel1': '\u5c0e\u51fa\u904b\u8f38\u6642\u9593 Excel',
  'IM_EX_Report': '\u9032\u51fa\u53e3\u7d71\u8a08',
  'IM_EX_Report_time': '\u65e5\u671f',
  'IM_EX_Report_total': '\u7e3d\u8a08',
  "login_expired": "\u767b\u9304\u5df2\u904e\u671f\uff0c\u8acb\u91cd\u65b0\u767b\u9304",
  "request_timeout": "\u670d\u52d9\u97ff\u61c9\u8d85\u6642\uff0c\u8acb\u7a0d\u540e\u518d\u8a66\uff01",
  "network_error": "\u7121\u6cd5\u8a2a\u554f\u670d\u52d9\uff0c\u670d\u52d9\u4e0d\u5b58\u5728\u6216\u7db2\u7d61\u672a\u9023\u63a5",
  "userAccess_authenticate_user_code_is_required": "\u7528\u6236\u4ee3\u78bc\u5fc5\u586b",
  "userAccess_authenticate_user_name_is_required": "\u7528\u6236\u540d\u7a31\u5fc5\u586b",
  "userAccess_authenticate_user_pass_is_required": "\u7528\u6236\u5bc6\u78bc\u5fc5\u586b",
  "airway_bill_of_lading_least_one": "\u81f3\u5c11\u8f38\u5165\u4e00\u500b\u63d0\u55ae\u865f!",
  "page_not_exist": "\u8fd4\u56de\u767b\u9304\u9801\u9762",
  "Quarterly_Report": "季度報告",
  "Monthly_report": "月度報告",
  "comparison": "比對",
  "comparison_tile": "請選擇比對的月份",
  "Please_select_Origin_or_Dest": "請選擇目的地/出發地",
  "Select_month": '請選擇月份',
  "open": '展開',
  "close": '閉合',
  "difference": '差異',
  'download': '下載'
}